/**
 * @generated SignedSource<<4a196ef56676b5dcf55495b9bf292618>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type pantoneLibraryColorsContainer_colors$data = {
  readonly paletteColors: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly cmykHexCode: string | null;
        readonly colorID: number;
        readonly id: string;
        readonly name: string;
        readonly rgbHexCode: string;
        readonly spotColorName: string | null;
      };
    }> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    };
  } | null;
  readonly palettesWithColors: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly isZakekeDefault: boolean;
        readonly name: string;
        readonly paletteTypeID: number;
        readonly useConversionTable: boolean;
      };
    }> | null;
  } | null;
  readonly " $fragmentType": "pantoneLibraryColorsContainer_colors";
};
export type pantoneLibraryColorsContainer_colors$key = {
  readonly " $data"?: pantoneLibraryColorsContainer_colors$data;
  readonly " $fragmentSpreads": FragmentRefs<"pantoneLibraryColorsContainer_colors">;
};

import pantoneLibraryColorsContainerQuery_graphql from './pantoneLibraryColorsContainerQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = [
  "paletteColors"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": "1",
      "kind": "LocalArgument",
      "name": "after"
    },
    {
      "defaultValue": 70,
      "kind": "LocalArgument",
      "name": "first"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "id"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "onlyDefaultColors"
    },
    {
      "defaultValue": "DESC",
      "kind": "LocalArgument",
      "name": "orderBy"
    },
    {
      "defaultValue": 1,
      "kind": "LocalArgument",
      "name": "paletteTypeID"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "search"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "useConversionTable"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [],
      "operation": pantoneLibraryColorsContainerQuery_graphql
    }
  },
  "name": "pantoneLibraryColorsContainer_colors",
  "selections": [
    {
      "alias": "paletteColors",
      "args": [
        {
          "kind": "Variable",
          "name": "id",
          "variableName": "id"
        },
        {
          "kind": "Variable",
          "name": "onlyDefaultColors",
          "variableName": "onlyDefaultColors"
        },
        {
          "kind": "Variable",
          "name": "orderBy",
          "variableName": "orderBy"
        },
        {
          "kind": "Variable",
          "name": "paletteTypeID",
          "variableName": "paletteTypeID"
        },
        {
          "kind": "Variable",
          "name": "search",
          "variableName": "search"
        },
        {
          "kind": "Variable",
          "name": "useConversionTable",
          "variableName": "useConversionTable"
        }
      ],
      "concreteType": "PaletteColorsConnection",
      "kind": "LinkedField",
      "name": "__pantoneLibraryColorsContainerColorsQuery_paletteColors_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PaletteColorsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "PaletteColor",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "colorID",
                  "storageKey": null
                },
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rgbHexCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cmykHexCode",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "spotColorName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PalettesWithColorsConnection",
      "kind": "LinkedField",
      "name": "palettesWithColors",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PalettesWithColorsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Palette",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                (v2/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "useConversionTable",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "paletteTypeID",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "isZakekeDefault",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "e9f9fa87357b617f8b77c09c6f512a5b";

export default node;
